/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import React from 'react';
import PropTypes from 'prop-types';
import IMAGES from 'constants/Images';

import {ProgressBar} from 'components/ProgressBar';

import {
  PageWrapper,
  Card,
  CardContent,
  InputSection,
  InputLabel,
  InputWrapper,
  StyledInput,
  InputHelpText,
  BenefitsSection,
  BenefitsTitle,
  BenefitsGrid,
  BenefitCard,
  BenefitIcon,
  BenefitTitle,
  BenefitDescription,
  CardFooter,
  SecondaryButton,
  PrimaryButton,
  Icon,
  ValidIcon,
  LoaderContainer,
} from './PartnerGst.styles';
import './PartnerGst.css';

import {WealthyValidations} from 'helpers';

// Benefit Card Component
const BenefitCardComponent = ({icon, title, description}) => (
  <BenefitCard>
    <BenefitIcon>
      <Icon src={icon} alt={title} size="28px" />
    </BenefitIcon>
    <BenefitTitle>{title}</BenefitTitle>
    <BenefitDescription>{description}</BenefitDescription>
  </BenefitCard>
);

BenefitCardComponent.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const propTypes = {
  onChangeHandler: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isRedirectLoading: PropTypes.bool.isRequired,
  skipStep: PropTypes.func.isRequired,
  showSkipButton: PropTypes.bool.isRequired,
};

const PartnerGst = ({
  onChangeHandler,
  onSubmit,
  formData,
  isLoading,
  isRedirectLoading,
  skipStep,
  showSkipButton,
}) =>
  isRedirectLoading ? (
    <LoaderContainer>
      <ProgressBar
        subheading="Please wait while we fetch your kyc details"
        heading="Checking your GST details"
        waitTimeInSec={180}
        stopOnEndTime={true}
      />
    </LoaderContainer>
  ) : (
    <PageWrapper>
      <Card>
        <CardContent>
          <InputSection>
            <InputLabel htmlFor="gst-number">GST Number</InputLabel>
            <InputWrapper>
              <StyledInput
                id="gst-number"
                name="gstNo"
                value={formData.gstNo}
                onChange={onChangeHandler}
                placeholder="Enter your 15-digit GST number"
              />
              {WealthyValidations.validateFormField.gstGeneric(formData.gstNo) && (
                <ValidIcon>
                  <Icon src={IMAGES.greenTickFilled} alt="Valid" />
                </ValidIcon>
              )}
            </InputWrapper>
            <InputHelpText>
              Format: 22AAAAA0000A1Z5 (2-digit state code followed by PAN and other details)
            </InputHelpText>
          </InputSection>

          <BenefitsSection>
            <BenefitsTitle>Why GST Number is beneficial ?</BenefitsTitle>
            <BenefitsGrid>
              <BenefitCardComponent
                icon={IMAGES.shieldPlusHeart}
                title="Tax Compliance & Legal Benefits"
                description="Stay compliant with tax rules and gain legal recognition"
              />
              <BenefitCardComponent
                icon={IMAGES.handsBadge}
                title="Increased Credibility & Opportunity"
                description="Boost your reputation and access larger opportunities"
              />
              <BenefitCardComponent
                icon={IMAGES.arrowUptrendIcon}
                title="Better Tax Optimisation"
                description="Claim tax credits and optimize your tax liability"
              />
            </BenefitsGrid>
          </BenefitsSection>
        </CardContent>

        <CardFooter>
          <SecondaryButton onClick={skipStep}>Add GST Later</SecondaryButton>
          <PrimaryButton onClick={onSubmit} disabled={isLoading}>
            Continue
          </PrimaryButton>
        </CardFooter>
      </Card>
    </PageWrapper>
  );

PartnerGst.propTypes = propTypes;

export default PartnerGst;
